<script lang="ts">
  import { cn } from '$lib/utils';
  import { cva } from 'class-variance-authority';

  const CURRENT_INDICATOR_FULL_WIDTH = 16;
  const INDICATORS_WIDTH = 6;

  export let total: number;
  export let currentIndex = 0;

  export let videosProgress: number[] | undefined = undefined;

  let className: string | undefined = undefined;
  export { className as class };

  export let variant: 'default' | 'quiz' = 'default';

  $: currentVideoWidth =
    videosProgress?.length && videosProgress[currentIndex] != 0
      ? `${CURRENT_INDICATOR_FULL_WIDTH * (videosProgress[currentIndex] / 100)}px`
      : null;

  const host = cva(
    [
      'flex h-3 w-fit items-center gap-1 rounded-full p-1 transition-all duration-300 motion-reduce:transition-none'
    ],
    {
      variants: {
        variant: {
          default: 'bg-highlight/80',
          quiz: 'bg-highlight/8'
        }
      }
    }
  );

  const indicator = cva(
    ['h-full rounded-full  transition-all duration-300 motion-reduce:transition-none'],
    {
      variants: {
        variant: {
          default: 'bg-primary/18',
          quiz: 'bg-highlight/14'
        }
      }
    }
  );

  const active = cva(
    ['h-full rounded-full transition-all duration-300 motion-reduce:transition-none'],
    {
      variants: {
        variant: {
          default: 'bg-primary/96',
          quiz: 'bg-highlight'
        }
      }
    }
  );
</script>

<div class={cn(host({ variant }), className)}>
  {#each [...Array(total)] as _, i}
    <div
      class={cn(indicator({ variant }))}
      style:width={i === currentIndex
        ? `${CURRENT_INDICATOR_FULL_WIDTH}px`
        : `${INDICATORS_WIDTH}px`}
    >
      {#if i === currentIndex}
        <div class={cn(active({ variant }))} style:width={currentVideoWidth} />
      {/if}
    </div>
  {/each}
</div>
